import React from 'react' 

const NoRecordsFound = ({message = "No records found"}) => (
    <div className="no-records-found">
        <span>{message}</span>
    </div>
)

export default NoRecordsFound